import { constants } from "@newsela/angelou";
import type { CSSObject } from "@emotion/react";
const {
  colors: { ui, brand, status },
} = constants;

const greyExtraLight = ui.neutral[25];
const greyDark = ui.neutral[600];
const yellow500 = ui.yellow[500];
const brandYellow50 = brand.bisque[50];
const green500 = ui.green[500];
const success300 = status.success[300];
const commonSpacingPx = "20px";

export const formCardContainerCss = {
  backgroundColor: greyExtraLight,
  borderRadius: "8px",
  color: greyDark,
  display: "grid",
  gridColumns: "1fr",
  padding: commonSpacingPx,
  alignItems: "stretch",
};

export const anchorCss = {
  alignSelf: "end",
};

export const cardTitleCss = {
  fontSize: "1.5rem",
  fontWeight: 700,
  marginBottom: "8px",
  height: "61px",
  lineHeight: "133%",
};

export const completePercentageBarCss = {
  border: `2px solid ${yellow500}`,
  backgroundColor: brandYellow50,
  paddingLeft: "12px",
};

export const percentageBarSharedCss = {
  fontSize: "14px",
  borderRadius: "10px",
  margin: "8px 0px",
};
export const incompletePercentageBarCss: CSSObject = {
  position: "relative",
  border: `2px solid ${yellow500}`,
  backgroundColor: brandYellow50,
  height: "24px",
};

export const incompleteFillPercentageCss = (percentage: number): CSSObject => ({
  position: "absolute",
  backgroundColor: yellow500,
  width: `${percentage}%`,
  height: "22px",
  borderRadius: "7px 0 0 7px",
});

export const percentageCopyCss: CSSObject = {
  position: "absolute",
  paddingLeft: "12px",
};

export const completePercentageCss = {
  fontWeight: 700,
  border: `2px solid ${green500}`,
  backgroundColor: success300,
  paddingLeft: "12px",
};

export const percentageContainer = {
  height: "40px",
};
